import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';

export type AlertProps = MuiAlertProps;

export const Alert = (props: AlertProps) => {
  return <MuiAlert {...props} />;
};
